import { gql } from '@apollo/client'

export const AddChat = gql`
    mutation AddChat($roomId: ID!, $text: String!) {
        addChat(roomId: $roomId, text: $text) {
            actor {
                id
                username
            }
            id
            text
            updated
        }
    }
`

export default AddChat
